import { render, staticRenderFns } from "./confirm-popover.vue?vue&type=template&id=58b8402d"
import script from "./confirm-popover.vue?vue&type=script&lang=ts"
export * from "./confirm-popover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58b8402d')) {
      api.createRecord('58b8402d', component.options)
    } else {
      api.reload('58b8402d', component.options)
    }
    module.hot.accept("./confirm-popover.vue?vue&type=template&id=58b8402d", function () {
      api.rerender('58b8402d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/confirm-popover.vue"
export default component.exports